/**
 * Contact JS
 */

// Vendors
import $ from 'jquery';

// Config
let map;
let marker;

// Init map
window.initMap = () => {
  map = new google.maps.Map(document.getElementById('map'), {
    center: window.initMarkerLocation,
    zoom: 15,
    scrollwheel: false,
  });

  marker = new google.maps.Marker({
    position: window.initMarkerLocation,
    map: map,
  });
};

$(function() {
    $('.contact-form__checkbox--budget .first').addClass('selected');
});

$('.contact-form__checkbox--budget .wpcf7-list-item input:checkbox').change(function(){
    var ischecked= $(this).is(':checked');
    if(ischecked) {
    	  $('.contact-form__checkbox--budget .wpcf7-list-item.selected').removeClass('selected');
        $(this).closest('.wpcf7-list-item').addClass("selected");
    }
    else {
        $('.contact-form__checkbox--budget .wpcf7-list-item.selected').removeClass('selected');
    }
});


$('.contact-form__toggle .wpcf7-list-item.last input:radio').change(function(){
    if($(this).is(":checked")) {
        $(this).closest('.form__toggle').addClass("selected");
    } 
});

$('.contact-form__toggle .wpcf7-list-item.first input:radio').change(function(){
    if($(this).is(":checked")) {
        $(this).closest('.form__toggle').removeClass("selected");
    }
});


// WEBPACK FOOTER //
// assets/js/contact.js